import types from '../../../realEstateTypes.js';
import inputsConfig from '../../PriceCheckInput/inputsConfig.js';

const { ZIP_CODE, LIVING_AREA, PLOT_AREA } = inputsConfig;

const inputs = {
  [ZIP_CODE]: {
    type: 'number',
    title: 'PLZ',
    placeholder: 'z.B. 14057',
    maxNumber: 99999,
    minNumber: 1,
    name: ZIP_CODE,
  },
  [LIVING_AREA]: {
    type: 'number',
    title: 'Wohnfläche',
    placeholder: '180',
    inputInfoText: 'm²',
    name: LIVING_AREA,
  },
  [PLOT_AREA]: {
    type: 'number',
    title: 'Grundstück',
    placeholder: '800',
    inputInfoText: 'm²',
    name: PLOT_AREA,
  },
};

export const RENT = { inputs: [] };

export const HOUSE_RENT = {
  inputs: [inputs[ZIP_CODE], inputs[LIVING_AREA], inputs[PLOT_AREA]],
};

export const APARTMENT_RENT = {
  inputs: [inputs[ZIP_CODE], inputs[LIVING_AREA]],
};

export const APARTMENT_BUY = {
  inputs: [inputs[ZIP_CODE], inputs[LIVING_AREA]],
};

export const HOUSE_BUY = {
  inputs: [inputs[ZIP_CODE], inputs[LIVING_AREA], inputs[PLOT_AREA]],
};

const TYPE_CONFIG = {
  [types.HOUSE_BUY]: HOUSE_BUY,
  [types.HOUSE_RENT]: HOUSE_RENT,
  [types.APARTMENT_BUY]: APARTMENT_BUY,
  [types.APARTMENT_RENT]: APARTMENT_RENT,
};

function getFor(realEstateType) {
  return TYPE_CONFIG[realEstateType] || TYPE_CONFIG[types.APARTMENT_BUY];
}

export default {
  getFor,
};
